export const FILTER_AND_SEARCH_B_TEMPLATE_ID = '43bf8423-58e1-4a30-9004-72831ae63a4e';

const PRODUCT_VARIANT_TEMPLATE_A = '15B61ED8-C3B8-4AAE-AFC6-EF28851F5EBD';
const PRODUCT_VARIANT_TEMPLATE_B = '9FB7FDF2-0AC4-4CBA-AD9A-F42E2EE52687';
const PRODUCT_VARIANT_TEMPLATE_C = '826693F8-CB93-410A-9DD2-6A16A5C83A14';

const LANDING_VARIANT_TEMPLATE_A = '49AF9BE4-1E52-4FF2-8A84-7E677DEC647D';
const LANDING_VARIANT_TEMPLATE_B = '43BF8423-58E1-4A30-9004-72831AE63A4E';
const LANDING_VARIANT_TEMPLATE_C = '717E16C2-AD59-415D-BC53-878CEC323201';

// 🔹 Separate lists
export const PRODUCT_VARIANT_TEMPLATE_IDS = [
  PRODUCT_VARIANT_TEMPLATE_A,
  PRODUCT_VARIANT_TEMPLATE_B,
    PRODUCT_VARIANT_TEMPLATE_C,
];

export const LANDING_VARIANT_TEMPLATE_IDS = [
  LANDING_VARIANT_TEMPLATE_A,
  LANDING_VARIANT_TEMPLATE_B,
  LANDING_VARIANT_TEMPLATE_C,
];
